export const basicAbility = [
  {
    action: 'read',
    subject: 'core'
  }
]

export const acquireAbility = [
  {
    action: 'read',
    subject: 'acquire'
  },
  {
    action: 'read',
    subject: 'data'
  }
]

export const superAdmin = [
  {
    action: 'manage',
    subject: 'all'
  }
]

export const adminAbility = [
  {
    action: 'update',
    subject: 'settings'
  },
  {
    action: 'create',
    subject: 'user'
  }
]

export const analyticAbility = [
  {
    action: 'read',
    subject: 'analytic'
  },
  {
    action: 'create',
    subject: 'analytic'
  }
]

export const employeesAbility = [
  {
    action: 'read',
    subject: 'employees'
  },
  {
    action: 'read',
    subject: 'data'
  }
]

export const budgetAbility = [
  {
    action: 'read',
    subject: 'budget'
  },
  {
    action: 'create',
    subject: 'budget'
  }
]

export const companyAbility = [
  {
    action: 'read',
    subject: 'company'
  },
  {
    action: 'read',
    subject: 'data'
  }
]